<template>
  <Tab no-help @close="removeCurrent">
    <template #toolbar-help>
      <v-btn class="tw-mr-2" fab text x-small :title="$t('dashboard.help.show')" @click="showHelp(menu,page)">
            <span class="mr-1">
              <v-icon color="primary" x-small>fa fa-question</v-icon>
            </span>
      </v-btn>
    </template>
    <template #toolbar-items>
      <!-- Reviews menu -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'reviews'"
        icon="fa-splotch"
        name="reviews"
      ></TabToolbarButton>
      <!-- Product menu -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'products'"
        icon="fa-tags"
        name="products"
      ></TabToolbarButton>
    </template>
    <template #container>
      <!-- ------------------------ Reviews ------------------------ -->
      <TabPage :menu="menu" :page="page" name="reviews" no-documentation>
        <template #content>
          <Moderation ref="moderation" type="reviews" :visible="page === 'reviews'" />
        </template>
      </TabPage>
      <!-- ------------------------ Products ------------------------ -->
      <TabPage :menu="menu" :page="page" name="products" no-documentation>
        <template #content>
          <Moderation ref="moderation" type="products" :visible="page === 'products'" />
        </template>
      </TabPage>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :timeout="snackbarTimeout"
        :multi-line="true"
        text
        outlined
        tile
        app
        top
      >
        {{ snackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn icon @click="snackbar = false">
            <v-icon :color="snackbarColor" small>fa-times</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import Moderation from "./Moderation"


export default {
  name: "Reviews",
  mixins: [tab],
  components: {
    Moderation,
  },
  data: () => ({
    pages: ["reviews", "products", "manual", "emailing", "csv"],
    menu: "moderation",
    page: "reviews",
    snackbar: false,
    snackbarTimeout: 2000,
    snackbarText: "",
    snackbarColor: "success",
  }),
  watch: {
    selectedWebsite(value) {
      this.fetchStories(value)
    },
    selectedSolicitationsWebsite() {
      this.fetchSolicitations()
    },
    solicitation(value) {
      if (value !== undefined && value !== null) {
        this.solicitationDialog = true
      } else {
        this.solicitationDialog = false
      }
    },
  },
  mounted() {
  },
  methods: {
    closeSolicitationDialog() {
      this.solicitationDialog = false
      this.solicitation = null
    },
    selectSolicitation(solicitation) {
      this.solicitation = solicitation
    },
    fetchSolicitations() {
      const query = [
        `page=${encodeURIComponent(this.solicitations_pagination.current_page)}`,
        `website_id=${encodeURIComponent(this.selectedSolicitationsWebsite)}`,
      ].join("&")

      this.$axios.get(`/office/manager/solicitations/list?${query}`).then(response => {
        this.solicitations = response.data.data
        this.solicitations_pagination = response.data
      })
    },
    getFormDataFromFiles() {
      let formData = new FormData()
      this.files.forEach((f, x) => {
        formData.append("file" + (x + 1), f)
      })
      return formData
    },
  },
}
</script>
